const backend_url = 'https://dms-dev.citriot.ai/api/';
// const backend_url = 'http://localhost:8000/api/';
const socket_url = 'http://localhost:8000';

module.exports = {
    backend_url,
    socket_url
};